import { Language } from '@ha/intl';

const availableLanguages = [Language.en];

export default (lang: Language) => availableLanguages.includes(lang);
